import { render, staticRenderFns } from "./NewDReleasePlatformPreview.vue?vue&type=template&id=0bbae004&"
import script from "./NewDReleasePlatformPreview.vue?vue&type=script&lang=js&"
export * from "./NewDReleasePlatformPreview.vue?vue&type=script&lang=js&"
import style0 from "./NewDReleasePlatformPreview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports